import { useState, useEffect } from 'react';
import { SET_CATEGORIES, SET_MAINTENANCE, SET_PRODUCTS, SET_CONFIG } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'utils/axios';

const useMaintenance = () =>  {

  const products = useSelector((state) => state?.shop?.products);
  const categories = useSelector((state) => state?.shop?.categories?.categories);
  // debugger
  const market_config = useSelector((state) => state.shop.config)
  if(market_config === undefined){
      const get_config = async () => {
          try {
              const configResponse = await axios.get(`/config_for_hostname/${window.location.hostname}`);
              const config = configResponse.data;
              // Dispatch config
              dispatch({
                  type: SET_CONFIG,
                  payload: config
              });
              
          } catch (err) {
          console.error(err);
          }
      }
      get_config();
  }

  const dispatch = useDispatch();

  const [maintenance, setMaintenance] = useState({}); // we could use SWR or usePersistenState here ?
  
  useEffect(() => {      
    const get_products = async () => {
      try {

        const token = window.localStorage.getItem('token');

        if (token) {
          if(!products || products.length === 0) {
            const productsResponse = await axios.get('/product');
            const allProducts = productsResponse.data;
            const products = allProducts.filter(prod =>
              market_config?.id ? //check if market config is avaiable
              prod?.organisation?.id === market_config?.id //if market config is available, filter products by market
              : true //fallback to true and return all products if market config is not available
            );
            if( products.length > 0 ){
              dispatch({ type: SET_PRODUCTS, products });
            } else {
              dispatch({ type: SET_PRODUCTS, allProducts });
            }
          }

          if(!categories) {
            const categoriesResponse = await axios.get('/category');
            const allCategories = categoriesResponse.data;
            const categories = allCategories.filter(cat => 
              market_config?.id ? //check if market config is avaiable
              cat?.organisation?.id === market_config?.id //if market config is available, filter categories by market
              : true //fallback to true and return all categories if market config is not available
            );
            if(categories.length > 0 ){
              dispatch({ type: SET_CATEGORIES, categories });
            } else {
              dispatch({ type: SET_CATEGORIES, allCategories });
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
    if (!market_config) {
      console.log('setting null');
      dispatch({ type: SET_MAINTENANCE, payload: null });
    } else {

      get_products();
      dispatch({ type: SET_MAINTENANCE, payload: {...market_config}});
    }
    setMaintenance( {...market_config} )
  }, [dispatch, market_config]);

  return maintenance;
}

export default useMaintenance;